import * as React from "react";
import { AdminMedicineModel, MedicineFilterSettings, MedicineGridModel } from "../../models/medicine/";
import MedicinesList from './medicineList';
import MedicineService from '../../services/medicineService';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Spinner from '../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import { MedicineFilter } from './medicineFilter';
import MedicinesAddEditDialog from './medicineAddEditDialog';
import { Lang } from '../../common/enums';
import { MedicineContentModel } from "../../models/medicine/medicineContent";
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { AdminMedicineSpecificationModel } from "../../models/medicine/adminMedicineSpecificationModel";
import { MedicineSpecificationContentModel } from "../../models/medicine/medicineSpecificationContentModel";
import { MedicineOverviewContentModel } from "../../models/medicine/medicineOverviewContentModel";

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./medicinesAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
	medicineGrid: MedicineGridModel,
	medicines: Array<AdminMedicineModel>;
	isLoading: boolean;
	error: any;
	validationMessage: string;
	isVisibleDialog: boolean;
	isVisibleDialogWrap: boolean;
	isVisibleConfirmDialog: boolean;
	currentMedicine: AdminMedicineModel;
	from: number;
	numberOfRows: number;
	totalRecordsCount: number;
	medicineSettings: MedicineFilterSettings
}

const initFrom = 0;
const numberOfRows = 10;

class MedicineContainer extends React.Component<IProps, IState> {

	medicineService = new MedicineService();
	messages: any;

	constructor(props: IProps) {
		super(props);

		this.state = {
			error: null,
			validationMessage: '',
			medicines: new Array<AdminMedicineModel>(0),
			isLoading: false,
			isVisibleDialog: false,
			isVisibleDialogWrap: false,
			isVisibleConfirmDialog: false,
			currentMedicine: new AdminMedicineModel(),
			from: initFrom,
			numberOfRows: numberOfRows,
			totalRecordsCount: 0,
			medicineGrid: new MedicineGridModel(),
			medicineSettings: new MedicineFilterSettings()
		};
	}

	// events
	componentDidMount() {
		this.getAllMedicines(this.state.from, this.state.numberOfRows);
	}

	// handles
	handleAddAndEditClick = id => {
		if (!id) { // Add		
			let medicine = new AdminMedicineModel();

			let contentList = new Array<MedicineContentModel>(0);
			let contentOvList = new Array<MedicineOverviewContentModel>(0);
			const langKeys = HelperFunctions.getEnumKeys(Lang);

			langKeys.map(k => {
				let content = new MedicineContentModel();
				content.langId = parseInt(Lang[k]);
				content.brandName = '';
				content.additionalTitle = '';
				contentList.push(content);
			});

			langKeys.map(k => {
				let content = new MedicineOverviewContentModel();
				content.langId = parseInt(Lang[k]);
				content.overviewSummary = '';
				content.overviewAboutMedicine = '';
				content.overviewBeforeIntake = '';
				content.overviewDosage = '';
				content.overviewSideEffects = '';
				content.overviewSafetyData = '';
				content.overviewAdditionalInfo = '';
				content.fullDescription = '';
				contentOvList.push(content);
			});

			medicine.medicineContent = contentList;
			medicine.medicineOverviewContent = contentOvList;
			medicine.specification = new AdminMedicineSpecificationModel();
			let specContList = new Array<MedicineSpecificationContentModel>(0);
			langKeys.map(k => {
				let content = new MedicineSpecificationContentModel();
				content.langId = parseInt(Lang[k]);
				content.description = '';
				content.pharmaceuticalForm = '';
				content.color = '';
				content.shape = '';
				content.packaging = '';
				content.packageSize = '';
				content.ddd = '';
				content.score = '';
				content.flavour = '';
				content.containsDesc = '';
				specContList.push(content);
			});
			medicine.specification.medicineSpecificationContent = specContList;
			this.setcurrentMedicine(medicine);
			this.showEditDialog(true);
		} else { // Edit
			this.setState({
				isLoading: true
			});
			this.medicineService.getMedicine(id)
				.then(
					(data: AdminMedicineModel) => {
						this.setcurrentMedicine(data);
						this.showEditDialog(true);
						this.setState({
							isLoading: false
						});
					},
					error => {
						this.setState({
							error,
							isLoading: false
						});
					}
				);
		}
	};

	getMedicine = (id) => {
		this.medicineService.getMedicine(id)
			.then(
				(data: AdminMedicineModel) => {
					this.setcurrentMedicine(data);
					this.setState({
						isLoading: false
					});
				},
				error => {
					this.setState({
						error,
						isLoading: false
					});
				});
	}

	handleDeleteClick = (id) => {
		this.getMedicine(id);
		this.setState({
			isVisibleConfirmDialog: true
		});
	};

	deleteMedicine(id) {
		this.setState({
			isVisibleConfirmDialog: false,
			isLoading: true
		});

		this.medicineService.deleteMedicine(id)
			.then(
				data => {
					this.getAllMedicines(this.state.from, this.state.numberOfRows);
					this.setState({
						isLoading: false
					});
				},
				error => {
					this.setState({
						error,
						isLoading: false
					});
				});
	}

	handleSaveButton = (currentMedicine: AdminMedicineModel, close: boolean) => {
		this.setState({
			isLoading: true
		});

		if (!currentMedicine.medicineId) { // Add
			this.medicineService.addMedicine(currentMedicine)
				.then(
					(data) => {
						if (close) {
							this.showEditDialog(false);

						}
						this.setcurrentMedicine(new AdminMedicineModel());
						this.getAllMedicines(this.state.from, this.state.numberOfRows);
						this.setState({
							isLoading: false
						});
					},
					error => {
						this.showEditDialog(false);
						this.setcurrentMedicine(new AdminMedicineModel());
						this.setState({
							error
						});
						this.setState({
							isLoading: false
						});
					}
				);
		} else { // Edit
			this.medicineService.editMedicine(currentMedicine.medicineId, currentMedicine)
				.then(
					(data) => {
						if (close) {
							this.showEditDialog(false);
						}
						this.setcurrentMedicine(new AdminMedicineModel());
						this.getAllMedicines(this.state.from, this.state.numberOfRows);
						this.setState({
							isLoading: false
						});
					},
					error => {
						this.showEditDialog(false);
						this.setcurrentMedicine(new AdminMedicineModel());
						this.setState({
							error
						});
						this.setState({
							isLoading: false
						});
					});
		}
	};

	handleCancelButton = () => {
		this.showEditDialog(false);
	};

	// methods
	getAllMedicines(from: number, numberOfRows: number) {
		this.setState({
			isLoading: true
		});

		this.medicineService.getAllMedicines(from, numberOfRows, this.state.medicineSettings).then(
			(data: MedicineGridModel) => {
				this.setState({
					isLoading: false,
					from: from,
					medicines: data.medicines,
					totalRecordsCount: data.totalRecordsCount
				});
			})
			.catch(error => {
				this.setState({
					isLoading: false,
					error
				});
			});
	}

	setcurrentMedicine(medicine: AdminMedicineModel) {
		this.setState({ currentMedicine: { ...medicine } });
	}

	showEditDialog = (show: boolean) => {
		this.setState({
			isVisibleDialogWrap: show,
			validationMessage: ''
		});
		setTimeout(() => this.setState({
			isVisibleDialog: show
		}));
	};

	handleOnPageClick = (e) => {
		const startIndex = e.first;
		this.getAllMedicines(startIndex, this.state.numberOfRows);
	}

	handleSearchButtonClick = (settings) => {
		this.setState({
			isLoading: true
		});

		this.medicineService.getAllMedicines(initFrom, numberOfRows, settings).then(
			(data: MedicineGridModel) => {
				this.setState({
					isLoading: false,
					from: initFrom,
					medicines: data.medicines,
					medicineSettings: settings,
					totalRecordsCount: data.totalRecordsCount
				});
			})
			.catch(error => {
				this.setState({
					isLoading: false,
					error
				});
			});
	}

	// render
	public render() {

		const { medicines, isLoading, error } = this.state;

		return (
			<div>

				<h3>Medicines</h3>

				{isLoading ? <Spinner /> : null}

				{error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

				{this.state.isVisibleDialogWrap ? (
					<MedicinesAddEditDialog
						saveClick={this.handleSaveButton}
						cancelClick={this.handleCancelButton}
						currentMedicine={this.state.currentMedicine}
						isVisible={this.state.isVisibleDialog}
					/>
				) : null}

				<div className="mb-2">
					<button
						onClick={() => this.handleAddAndEditClick(null)}
						className="btn btn-success"
						style={{ marginRight: "5px" }}>
						Add New
         			 </button>
				</div>

				<MedicineFilter
					onSearchClick={this.handleSearchButtonClick}
					totalRecordsCount={this.state.totalRecordsCount}
				/>

				<MedicinesList
					medicines={medicines}
					rows={numberOfRows}
					totalRecords={this.state.totalRecordsCount}
					onPageClick={this.handleOnPageClick}
					first={this.state.from}
					loading={Spinner}
					editClick={this.handleAddAndEditClick}
					deleteClick={this.handleDeleteClick}
				/>

				<ConfirmDialog
					headerTitle="Confirm Dialog"
					isVisible={this.state.isVisibleConfirmDialog}
					yesClick={() => { this.deleteMedicine(this.state.currentMedicine.medicineId) }}
					noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
					Are you sure that you want to delete "{this.state.currentMedicine.brandName}"?
        </ConfirmDialog>
			</div>
		);
	}
}

export default MedicineContainer;
